import { CreateCMSTokenEndAction } from "../actions/CreateCMSToken";
import { AppState } from "../state";

export function createCMSToken(state: AppState, action: CreateCMSTokenEndAction): AppState {
    if (action.payload.error) {
        const errorMap = {
            ...state.errorMap,
            [action.type]: action.payload.error
        };

        return {
            ...state,
            errorMap
        };
    } else {
        const { appId, token } = action.payload;

        return {
            ...state,
            tokens: {
                ...state.tokens,
                [appId]: {
                    ...state.tokens[appId],
                    newToken: token
                }
            }
        };
    }
}
